import { boundApiRequest } from '@/restapi/restapi.base.js';

const doRequest = boundApiRequest('/api/tagKind/');


export async function searchTagKind(query = '') {
    const { result } = await doRequest('find', {
        query,
        limit: 12,
    });

    return result;
}

export async function resolveTagKind(id) {
    const { result } = await doRequest('load', {
        id,
    });

    return result;
}
